import
  React
from 'react';

const BlueInfoIcon = () => {

  return (

    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.896 8.438a31.667 31.667 0 0 1 31.666 31.666 31.667 31.667 0 0 1-31.666 31.667A31.667 31.667 0 0 1 8.229 40.104 31.666 31.666 0 0 1 39.896 8.438" fill="#00B0CA" />
      <path d="M39.896 10.038a30.067 30.067 0 1 0 0 60.133 30.067 30.067 0 0 0 0-60.133M16.372 16.58A33.267 33.267 0 1 1 63.42 63.628a33.267 33.267 0 0 1-47.046-47.046" fill="#00B0CA" />
      <path d="M35.067 34.896a1.6 1.6 0 0 1 1.6-1.6H40a1.6 1.6 0 0 1 1.6 1.6V54.27a1.6 1.6 0 1 1-3.2 0V36.496h-1.733a1.6 1.6 0 0 1-1.6-1.6" fill="#fff" />
      <path d="M35.067 54.896a1.6 1.6 0 0 1 1.6-1.6h6.667a1.6 1.6 0 0 1 0 3.2h-6.667a1.6 1.6 0 0 1-1.6-1.6m4.1-28.4a1.183 1.183 0 1 0 0-2.367 1.183 1.183 0 0 0 0 2.367m-2.017-1.183a2.017 2.017 0 1 1 4.033 0 2.017 2.017 0 0 1-4.033 0" fill="#fff" />
    </svg>
  );
};

export default BlueInfoIcon;
